import React from 'react';
import { Link } from 'react-router-dom';
import {
  TbAlertTriangle,
  TbBrandInstagram,
  TbBrandWhatsapp,
  TbCircleX,
  TbMail,
  TbPhone,
  TbShieldCheck,
  TbVideo,
  TbWorld
} from 'react-icons/tb';
import { LAWYERS, OFFICE, getTelLink, getWhatsAppLink } from '../data/escritorio';
import { usePageMeta } from '../utils/seo';
// Estilos base (.nvh-*) vêm de Home.css; a estrutura de página, de Guia.css.
import './Home.css';
import './Guia.css';
import './Golpe.css';

const NUNCA = [
  {
    title: 'Pedir dinheiro por mensagem',
    text: 'Não pedimos PIX, depósito ou pagamento de taxas, custas ou "liberação de alvará" para você receber valores de um processo.'
  },
  {
    title: 'Pedir senhas ou códigos',
    text: 'Não pedimos senhas de banco ou do gov.br, nem códigos recebidos por SMS ou WhatsApp.'
  },
  {
    title: 'Pedir dados pessoais por mensagem',
    text: 'Não pedimos fotos de documentos, dados bancários ou cadastrais por WhatsApp sem que você tenha falado antes com o seu advogado.'
  },
  {
    title: 'Trocar de número',
    text: 'Nossos números são sempre os mesmos. Mensagem "do escritório" vinda de outro número é golpe.'
  }
];

const SINAIS = [
  'Contato de um número que você não conhece, dizendo que o advogado "trocou de telefone".',
  'Foto do advogado ou do escritório no perfil, para parecer verdadeiro.',
  'Dados reais do seu processo (número, nome das partes, vara), que são públicos e foram copiados pelos golpistas.',
  'Notícia boa e urgente: um valor a receber, uma decisão favorável, um prazo que "vence hoje".',
  'Pedido de pagamento para conta de outra pessoa ou empresa, ou de um código que chegou no seu celular.',
  'Convite para uma "audiência" por videochamada enviado por número desconhecido.',
  'Recusa em atender ligação ou em falar no telefone fixo do escritório.'
];

const AUDIENCIA_VERDADEIRA = [
  'É marcada pelo juiz dentro do processo e comunicada por intimação oficial. Quando você é nosso cliente, nós avisamos e participamos com você.',
  'O link de uma audiência verdadeira vem do tribunal ou do seu advogado, pelos contatos oficiais desta página.',
  'Nenhum juiz, promotor, servidor do fórum ou advogado pede PIX, pagamento de "acordo", custas ou dados bancários durante uma audiência.'
];

const PASSOS = [
  { strong: 'Não pague, não envie dados e não repasse nenhum código.', text: 'Encerre a conversa ou a videochamada.' },
  {
    strong: 'Ligue para um dos nossos números oficiais',
    text: '(os desta página), e não para o número que mandou a mensagem. Confirmamos na hora se o contato foi nosso.'
  },
  {
    strong: 'Se já fez um PIX, procure o seu banco imediatamente',
    text: 'e peça a contestação pelo MED (Mecanismo Especial de Devolução). Quanto antes, maior a chance de recuperar o valor.'
  },
  {
    strong: 'Registre um boletim de ocorrência,',
    text: 'em uma delegacia ou pela Delegacia Eletrônica da Polícia Civil do Paraná, guardando prints da conversa e o número usado.'
  },
  { strong: 'Denuncie o número no próprio WhatsApp', text: 'e nos avise, para alertarmos outros clientes.' }
];

const Golpe = () => {
  usePageMeta({
    title: 'Golpe do falso advogado: como se proteger',
    description:
      'A Navarro & Vieira Advogados não pede dinheiro, senhas ou dados pessoais por mensagem e não troca de número. Saiba reconhecer mensagens e audiências falsas por videochamada e veja nossos contatos oficiais.'
  });

  return (
    <div className="nvh nvg">
      <section className="nvg-hero nvgp-hero">
        <div className="nvh-wrap">
          <nav className="nvg-breadcrumb" aria-label="Caminho">
            <Link to="/">Início</Link>
            <span aria-hidden="true">›</span>
            <span aria-current="page">Golpe do falso advogado</span>
          </nav>
          <div className="nvgp-alert">
            <TbAlertTriangle aria-hidden="true" />
            Alerta de segurança
          </div>
          <h1>Golpe do falso advogado: não pedimos dinheiro, senhas ou dados por mensagem</h1>
          <p className="nvg-subtitle">
            Golpistas estão usando nomes de advogados e dados públicos de processos para enganar clientes, inclusive com
            audiências falsas por videochamada. Veja como identificar o golpe e quais são os nossos únicos canais de
            contato.
          </p>
        </div>
      </section>

      <section className="nvg-body">
        <div className="nvh-wrap nvg-layout">
          <article className="nvg-article">
            <div className="nvg-section">
              <h2>O que a Navarro &amp; Vieira nunca faz</h2>
              <div className="nvgp-never">
                {NUNCA.map((item) => (
                  <div key={item.title} className="nvgp-never-item">
                    <TbCircleX className="nvgp-never-icon" aria-hidden="true" />
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="nvg-p nvgp-note">
                Honorários são combinados em contrato escrito, diretamente com os advogados. Valores recebidos em processos
                não dependem de nenhum pagamento antecipado.
              </p>
            </div>

            <div className="nvg-section" id="contatos-oficiais">
              <h2>Nossos únicos contatos oficiais</h2>
              <div className="nvgp-contacts">
                <a className="nvgp-contact" href={getTelLink(OFFICE.phone)}>
                  <TbPhone aria-hidden="true" />
                  <span>
                    <strong>{OFFICE.phone}</strong>
                    <span>Telefone do escritório</span>
                  </span>
                </a>
                {LAWYERS.map((lawyer) => (
                  <a
                    key={lawyer.email}
                    className="nvgp-contact"
                    href={getWhatsAppLink(lawyer.phone)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <TbBrandWhatsapp aria-hidden="true" />
                    <span>
                      <strong>{lawyer.phone}</strong>
                      <span>WhatsApp · {lawyer.name}</span>
                    </span>
                  </a>
                ))}
                <div className="nvgp-contact">
                  <TbMail aria-hidden="true" />
                  <span>
                    <strong>{OFFICE.emailDomain}</strong>
                    <span>Únicos e-mails do escritório</span>
                  </span>
                </div>
                <a className="nvgp-contact" href={OFFICE.instagramUrl} target="_blank" rel="noopener noreferrer">
                  <TbBrandInstagram aria-hidden="true" />
                  <span>
                    <strong>{OFFICE.instagram}</strong>
                    <span>Instagram oficial</span>
                  </span>
                </a>
                <div className="nvgp-contact">
                  <TbWorld aria-hidden="true" />
                  <span>
                    <strong>navarroevieiraadvogados.com.br</strong>
                    <span>Site oficial</span>
                  </span>
                </div>
              </div>
              <p className="nvg-p nvgp-note">
                <strong>Não trocamos de número.</strong> Se receber mensagem de outro número dizendo ser do escritório ou de
                um dos nossos advogados, não responda e ligue para um dos números acima.
              </p>
            </div>

            <div className="nvg-section">
              <h2>Como o golpe costuma acontecer</h2>
              <p className="nvg-p">
                Os dados básicos de muitos processos são públicos. Os golpistas copiam o número do processo, o nome das
                partes e o nome do advogado e entram em contato pelo WhatsApp, fingindo ser o escritório. Fique atento a
                estes sinais:
              </p>
              <ul className="nvg-list">
                {SINAIS.map((s) => (
                  <li key={s}>{s}</li>
                ))}
              </ul>
            </div>

            <div className="nvg-section" id="audiencias-falsas">
              <h2>Audiências falsas por videochamada</h2>
              <div className="nvgp-video">
                <TbVideo aria-hidden="true" />
                <p>
                  Uma variação do golpe simula uma audiência. O golpista marca uma videochamada pelo WhatsApp, Zoom, Teams ou
                  Google Meet com pessoas se passando por juiz, promotor de justiça, servidor do fórum ou advogado, às vezes com
                  toga, brasão e fundo de sala de audiência. Durante a chamada, pressiona a pessoa a pagar na hora uma taxa, um
                  &quot;acordo&quot; ou custas, ou a mostrar documentos e informar dados.
                </p>
              </div>
              <p className="nvg-p">Como reconhecer uma audiência verdadeira:</p>
              <ul className="nvg-list">
                {AUDIENCIA_VERDADEIRA.map((s) => (
                  <li key={s}>{s}</li>
                ))}
              </ul>
              <p className="nvg-p nvgp-note">
                <strong>Recebeu convite para uma audiência que você não esperava?</strong> Não entre na chamada e confirme
                antes com o escritório, pelos números oficiais.
              </p>
            </div>

            <div className="nvg-section">
              <h2>Recebeu uma mensagem suspeita? Faça assim</h2>
              <ol className="nvg-steps">
                {PASSOS.map((item, index) => (
                  <li key={item.strong}>
                    <span className="nvg-step-number" aria-hidden="true">{index + 1}</span>
                    <span>
                      <strong>{item.strong}</strong> {item.text}
                    </span>
                  </li>
                ))}
              </ol>
            </div>
          </article>

          <aside className="nvg-aside">
            <div className="nvg-cta">
              <div className="nvh-eyebrow nvh-eyebrow-gold">Na dúvida, confirme</div>
              <h2>Ligue antes de fazer qualquer coisa</h2>
              <p>Confirmar leva um minuto. Use sempre os números desta página.</p>
              <a className="nvh-btn nvh-btn-gold" href={getTelLink(OFFICE.phone)}>
                <TbPhone aria-hidden="true" />
                Ligar {OFFICE.phone}
              </a>
            </div>
            <div className="nvg-others nvgp-safe">
              <TbShieldCheck aria-hidden="true" />
              <p>
                Mensagens verdadeiras do escritório nunca pedem pagamento, senha ou código, e vêm sempre dos números
                oficiais.
              </p>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default Golpe;
